import AbstractContextObject from "../../../../../shared/src/ranj/app/core/AbstractContextObject";
import SaveEvent from "../../../../../shared/src/ranj/equalture/savegame/SaveEvent";
import GameConfig from "../model/GameConfig";
import GameModel from "../model/GameModel";
import PuzzleModelEvent from "../model/PuzzleModelEvent";

export default class SaveController extends AbstractContextObject {

    /**
     * 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {GameModel} gameModel 
     * @param {GameConfig} gameConfig 
     */
    constructor(dispatcher, gameModel, gameConfig) {
        super(dispatcher);
        this._gameModel = gameModel;
        this._gameConfig = gameConfig;
        
        this._gameModel.addEventListener(PuzzleModelEvent.MOVE, this._handlePuzzleMove.bind(this));
        this._gameModel.addEventListener(PuzzleModelEvent.ELAPSED_TIME, this._handlePuzzleTime.bind(this));
        this._gameModel.addEventListener(PuzzleModelEvent.STATUS, this._handlePuzzleStatus.bind(this));

        this._lastSave = 0;
        this._lastTimeBasedSave = 0;
    }

    _handlePuzzleMove(e) {
        this._scheduleSave();
    }

    _handlePuzzleTime(e) {
        if (Date.now() - Math.max(this._lastTimeBasedSave, this._lastSave) > this._gameConfig.getValue("savegame.interval")) {
            this._lastTimeBasedSave = Date.now();
            this._scheduleSave();
        }        
    }
    
    _handlePuzzleStatus({ data: status }) {
        this._scheduleSave();
    }

    _scheduleSave() {
        if (this._delayedSave) {
            this.killDelayedCall(this._delayedSave);
        }
        this._delayedSave = this.callDelayed(this._save.bind(this), 50);
    }

    _save() {
        this._lastSave = Date.now();
        this.dispatch(SaveEvent.SAVE);
    }

}
